var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportingGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5 29.5H23.5V31H29.5V29.5Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 25.75H23.5V27.25H32.5V25.75Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.25 33.25H23.5V34.75H27.25V33.25Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.75 19.75H32.5V19C32.5 18.6022 32.342 18.2206 32.0607 17.9393C31.7794 17.658 31.3978 17.5 31 17.5H25C24.6022 17.5 24.2206 17.658 23.9393 17.9393C23.658 18.2206 23.5 18.6022 23.5 19V19.75H21.25C20.8522 19.75 20.4706 19.908 20.1893 20.1893C19.908 20.4706 19.75 20.8522 19.75 21.25V37C19.75 37.3978 19.908 37.7794 20.1893 38.0607C20.4706 38.342 20.8522 38.5 21.25 38.5H34.75C35.1478 38.5 35.5294 38.342 35.8107 38.0607C36.092 37.7794 36.25 37.3978 36.25 37V21.25C36.25 20.8522 36.092 20.4706 35.8107 20.1893C35.5294 19.908 35.1478 19.75 34.75 19.75ZM25 19H31V22H25V19ZM34.75 37H21.25V21.25H23.5V23.5H32.5V21.25H34.75V37Z",
    fill: "#B9B9B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportingGray);
export default __webpack_public_path__ + "static/media/reportingGray.6dcf5822a35958f86fceb91762226362.svg";
export { ForwardRef as ReactComponent };